import { format } from 'date-fns'

import {
  getEndMonthPeriodDate,
  getEndWeekPeriodDate
} from '../../../../forms/Multiplatform/MediaOrderForms/MediaOrderCreate/MediaOrderCreateForm/ContractCreateForm/helpers/periodHelpers'

import { DATES_FORMAT_MONTH_YEAR, DATES_FORMAT_SHORT } from '../../../../constants/dates'
import {
  PERIOD_DAY,
  PERIOD_ONE_MONTH,
  PERIOD_ONE_WEEK,
  PERIOD_TWO_MONTH,
  PERIOD_TWO_WEEKS
} from '../../../../constants/mediaOrders'

export const getFormattedMediaDate = (date, period) => {
  if (period === PERIOD_DAY) {
    return format(new Date(date), DATES_FORMAT_SHORT)
  } else if (period === PERIOD_ONE_WEEK) {
    return format(new Date(date), DATES_FORMAT_SHORT)
  } else if (period === PERIOD_TWO_WEEKS) {
    const endDate = getEndWeekPeriodDate(date, 2)
    return format(new Date(date), DATES_FORMAT_SHORT) + ' - ' + format(new Date(endDate), DATES_FORMAT_SHORT)
  } else if (period === PERIOD_ONE_MONTH) {
    return format(new Date(date), DATES_FORMAT_MONTH_YEAR)
  } else if (period === PERIOD_TWO_MONTH) {
    const endDate = getEndMonthPeriodDate(date, 1)

    return format(new Date(date), DATES_FORMAT_MONTH_YEAR) + ' - ' + format(new Date(endDate), DATES_FORMAT_MONTH_YEAR)
  }
}

export const getFormattedOtherParams = (otherParams = {}) => {
  return Object.entries(otherParams).reduce((acc, [key, value]) => {
    if (value) {
      return `${acc}&${key}=${value}`
    }
    return acc
  }, '')
}

export const getPeriodKeyFromFileRowIdAndCustomDate = ({ fileId, bookedMediaId, customDate }) => {
  // if file has custom date then we need to show one file per date, so add date to the id
  return `${fileId}_${bookedMediaId}${customDate ? `_${customDate}` : ''}`
}
